import React from 'react';
import { MapPinIcon, ScaleIcon, TargetIcon, HandshakeIcon } from 'lucide-react';
import { Section, SectionHeading } from './shared';
const differentiators = [{
  icon: MapPinIcon,
  title: 'Serving WA since 1990',
  body: "A long-established and trusted Perth injury law practice with deep knowledge of the Western Australian claims system. Compensation systems vary dramatically from state to state, which is why it's vital to engage a locally based, experienced WA injury lawyer who knows the system!"
}, {
  icon: ScaleIcon,
  title: 'Focused on injury law',
  body: 'Your claim is handled by a specialist team of injury lawyers whose professional work centres exclusively on compensation and personal injury law.'
}, {
  icon: TargetIcon,
  title: 'Expert claim strategy',
  body: 'Implementing expert claim strategy designed to maximise compensation in every claim.'
}, {
  icon: HandshakeIcon,
  title: 'Hard and experienced negotiators',
  body: "When it comes to settling your claim, you want a hard and experienced legal negotiator who is passionate about achieving the best result in your claim.\n\nIt's “in the blood”! We are passionate about our work and take pride in the way we handle and negotiate claims."
}];
export function WhySeparovic() {
  return <Section className="bg-paper" data-id="element-596" data-mp="16g57upsrff3l">
      <SectionHeading eyebrow="Why Separovic" title="Experience Without the Legal Runaround" intro="Established expertise matters. So does feeling heard, knowing who is handling your claim and understanding what happens next." align="center" data-id="element-597" data-mp="16f3jxkqnay4g" />

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-598" data-mp="jitk0rqbeu3d">
        {differentiators.map(item => {
        const Icon = item.icon;
        return <article key={item.title} className="grid h-full grid-cols-[auto_1fr] gap-4 rounded-card border border-ink/5 bg-canvas p-6 shadow-card" data-id="element-599" data-mp="2dw2xeulzezqw">
              <span className="flex h-11 w-11 items-center justify-center rounded-btn bg-warm-tint text-forest" data-id="element-600" data-mp="3qttof5ndc6cu">
                <Icon className="h-5 w-5" aria-hidden="true" strokeWidth={1.75} data-id="element-601" data-mp="3ltfjhwh2dcj1" />
              </span>
              <div data-id="element-602" data-mp="3htoh0vi6d7yo">
                <h3 className="text-[19px] font-semibold leading-[1.3] text-ink" data-id="element-603" data-mp="3ht59m8q5i1yw">
                  {item.title}
                </h3>
                <p className="mt-2 whitespace-pre-line text-[16px] leading-[1.55] text-slate" data-id="element-604" data-mp="denjw2qfjhrm">
                  {item.body}
                </p>
              </div>
            </article>;
      })}
      </div>
    </Section>;
}